import API, { pageSize } from "../constants/API"
import { generateRequestUrl } from "../utils/Global" 
import { notification } from "antd"
import axios from "axios"

const purchaseUrl = "http://localhost:8080/eftpos/purchase"
const messageUrl = "http://localhost:8080/eftpos/message"
const pressokUrl = "http://localhost:8080/eftpos/pressok"
const pressyesUrl = "http://localhost:8080/eftpos/pressyes"
const pressnoUrl = "http://localhost:8080/eftpos/pressno"
const receiptUrl = "http://localhost:8080/eftpos/receipt"

export const doPurchase = async (purchaseRequest: any) => {
  try {
    const response = await axios.post(purchaseUrl, purchaseRequest)
    console.log("doPurchase response: ", response)
  } catch (e) {
    console.log(e)
    notification.error({
      message: "Something went wrong!"
    })
    return e
  }
}

export const getMessage = async () => {
  try {
    const response = await axios.get(messageUrl)
    console.log("getMessage response: ", response)
    return response.data
  } catch (e) {
    console.log(e)
    notification.error({
      message: "Something went wrong!"
    })
    return e
  }
}
export const clearMessage = async (reason?: string) => {
  try {
    const response = await axios.post(messageUrl)
    console.log("clearMessage response: ", response, "and the reason is-> ", reason)
    return response.data
  } catch (e) {
    console.log(e)
    notification.error({
      message: "Something went wrong within clear message!"
    })
    return e
  }
}
/*
| EFTPOSKey | Description          |
| --------- | -------------------- |
| OKCancel  | CANCEL key or OK key |
| YesAccept | YES key              |
| NoDecline | NO key               |
| Authorise | AUTH key             |
*/
export const sendOK = async () => {
  try {
    const response = await axios.post(pressokUrl)
    console.log("sendOK response: ", response)
    return response.data
  } catch (e) {
    console.log(e)
    notification.error({
      message: "Something went wrong within send OK!"
    })
    return e
  }
}
export const sendYes = async () => {
  try {
    const response = await axios.post(pressyesUrl)
    console.log("sendYes response: ", response)
    return response.data
  } catch (e) {
    console.log(e)
    notification.error({
      message: "Something went wrong within send Yes!"
    })
    return e
  }
}
export const sendNo = async () => {
  try {
    const response = await axios.post(pressnoUrl)
    console.log("sendNo response: ", response)
    return response.data
  } catch (e) {
    console.log(e)
    notification.error({
      message: "Something went wrong within send No!"
    })
    return e
  }
}

export const getReceipt = async () => {
  try {
    const response = await axios.get(receiptUrl)
    console.log("response: ", response)
    return response.data
  } catch (e) {
    console.log(e)
    notification.error({
      message: "Something went wrong!"
    })
    return e
  }
}
